
import React from 'react';
import { CustomSelectContext } from './CustomSelectContext';

interface CustomSelectItemProps {
  value: string;
  children: React.ReactNode;
  onSelect?: () => void;
  onClick?: (e: React.MouseEvent) => void;
  style?: React.CSSProperties;
}

export const CustomSelectItem: React.FC<CustomSelectItemProps> = ({
  value,
  children,
  onSelect,
  onClick,
  style
}) => {
  const { onValueChange } = React.useContext(CustomSelectContext);

  const handleClick = (e: React.MouseEvent) => {
    console.log("CustomSelectItem clicked with value:", value);
    e.stopPropagation();
    
    onClick?.(e);
    onValueChange(value);
    onSelect?.();
  };

  return (
    <div
      className="px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer text-sm text-black dark:text-white whitespace-nowrap"
      onClick={handleClick}
      style={style}
    >
      {children}
    </div>
  );
};
